import { CLIENT_API_URL, fmhNpiAPI, POLICY_API_URL } from 'api/APIBase';

/** Gets referral details for the given referralId and clientId */
export async function getReferralDetails(referralId, payerId, npi) {
    const url = `${CLIENT_API_URL}/${payerId}/referrals/${referralId}/display`;
    return fmhNpiAPI({ url, npi }).get().json();
}

/** Gets policy list for given payer */
export async function getPolicyListForPayer(payerId, npi) {
    const url = `${POLICY_API_URL}/${payerId}/policies`;
    return fmhNpiAPI({ url, npi }).get().json();
}
